import{createTheme as t}from"@mui/material/styles";import{base as e}from"./base";const r=t({...e,palette:{...e.palette,mode:"light"}});export{r as light};
//# sourceMappingURL=light.js.map
